import { render } from "./CompaniaSistemaTipo.vue?vue&type=template&id=180c0ae6"
import script from "./CompaniaSistemaTipo.vue?vue&type=script&lang=js"
export * from "./CompaniaSistemaTipo.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__